import BrandOnboarding from './BrandOnboarding'

export default BrandOnboarding
